import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="drawer"
export default class extends Controller {
  connect() {
    this.resetDrawerFunction = this.resetDrawer.bind(this);

    document.addEventListener('turbo:before-cache', this.resetDrawerFunction);
    document.addEventListener('turbo:load', this.resetDrawerFunction);
  }

  disconnect() {
    document.removeEventListener('turbo:before-cache', this.resetDrawerFunction);
    document.removeEventListener('turbo:load', this.resetDrawerFunction);
  }

  resetDrawer() {
    document.querySelectorAll("input.drawer-toggle").forEach((input) => {
      if (input.checked) {
        input.checked = false;
      }
    });
  }
}
